import List from "#SRC/js/structs/List";
import Volume from "./Volume";

class VolumeList extends List {}
VolumeList.type = Volume;

module.exports = VolumeList;



// WEBPACK FOOTER //
// ./plugins/services/src/js/structs/VolumeList.js